export default __webpack_public_path__ + "static/media/pack2.5f402f02.png";